import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackDeleteWishListParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/wishList/trackDeleteWishList";

const useTrackDeleteWishList = (
    parameters: TrackDeleteWishListParameters = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.deleteWishList, parameters, options);
};

export default useTrackDeleteWishList;
